export default "__VITE_ASSET__BWVxgo1u__"